import initAliasDeleteModal from '../modules/alias-delete-modal';

const initialize = () => {
    initAliasDeleteModal();
};

export default initialize;
